import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AppKDS from './APPKDS';

ReactDOM.render(
//<FirebaseAppProvider firebaseConfig={firebaseConfig}>
    //<Suspense fallback={'conectando a la app'}>
        <App/>  
    //</Suspense>
//</FirebaseAppProvider>
, document.getElementById('root'));

